export default __webpack_public_path__ + "static/media/pink_hat.99b1699f.png";